import DatePicker from "react-datepicker";
import React, { useState } from "react";

export default function YearPicker({ onChange }: any) {
  const [selectedYear, setSelectedYear] = useState<any>(null);

  const handleYearChange = (year: Date | null) => {
    setSelectedYear(year);
    if (year) {
      const selectedYearString = year.getFullYear().toString();
      onChange(selectedYearString);
    } else {
      onChange(null);
    }
  };

  return (
    <div className="pull-left ws-12">
      <div className="ws-12 pull-left">
        <DatePicker
         placeholderText="Select Year"
          selected={selectedYear}
          onChange={handleYearChange}
          dateFormat="yyyy"
          showYearPicker
          isClearable
        />
      </div>
    </div>
  );
}